// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FolderAddOutlinedSvg from "@fishx/icons-svg/es/asn/FolderAddOutlined";
import FishxIcon from '../components/FishxIcon';

var FolderAddOutlined = function FolderAddOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FolderAddOutlinedSvg
  }));
};

FolderAddOutlined.displayName = 'FolderAddOutlined';
export default React.forwardRef(FolderAddOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FolderAddOutlined.js
// module id = 2793
// module chunks = 0